export type MediaKind = 'image' | 'video';

export function mapMediaKind(raw: string): MediaKind {
  return raw.toLowerCase() === 'video' ? 'video' : 'image';
}

export interface ApplicationListItemModel {
  appealId: string;
  appealName: string;
  mediaCount: number;
  hasUnreadMessages: boolean;
}

export interface ApplicationDetailModel {
  appealId: string;
  appealName: string;
}

export interface ApplicationMediaModel {
  id: string;
  kind: MediaKind;
  fileName: string;
  url: string;
  thumbnailUrl?: string;
  caption?: string;
}

export interface AppealMaterialModel {
  id: string;
  storageKey: string;
  kind: MediaKind;
  fileName: string;
  caption?: string | null;
  url: string;
  thumbnailUrl?: string | null;
  // Ключ миниатюры видео в хранилище (для видео; для фото — null). Используется как обложка
  // видео-экрана/истории при сборке истории из материалов.
  thumbnailStorageKey?: string | null;
}

export interface PagedView<T> {
  items: T[];
  totalCount: number;
  pageInfo: {
    endCursor?: string | null;
    hasNextPage?: boolean;
  };
}
